import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import axios from "axios";
import firebase from "./firebase";
import "firebase/database";

Vue.prototype.$database = firebase.database();
Vue.prototype.$firestore = firebase.firestore();
Vue.prototype.$axios = axios;

import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin)

import Vuebar from 'vuebar';
import './plugins/base';
import VueSkycons from 'vue-skycons';
Vue.use(VueSkycons, {
    color: '#1e88e5'
});
import JsonCSV from 'vue-json-csv'

Vue.component('downloadCsv', JsonCSV)
Vue.config.productionTip = false;

Vue.use(Vuebar);
firebase.auth().onAuthStateChanged((user) => {
    new Vue({
        vuetify,
        store,
        router,
        data:{
            isLga:false,
            from:2020,
            loading:true,
            selectedRange: "2020/2021",
            yearRanges: [
                "2020/2021",
                "2021/2022",
                "2022/2023",
                "2023/2024",
            ],
            result1:[],
            to:2021,
            loggedMail:'',
            months:['January','February','March','April','May','June','July','August','September','October','November','December'],    
            lgas:[],
            lgasAll:[],
            members:[],
            past_submissions:[],
            programs:[],
            cairns:[],
            mackay:[],
            whitsundays:[],
            selectedLga:"All LGAs",
            richmond:[],
            douglas:[],
            selectedMonth:'All',
            user:null,
            d:{},
        },
        computed:{
            },
        async mounted() {
            if(user) {
              console.log('logged user is', user)
                let us = this.$database.ref("01CNvKma7Ziku8l3RwGsKZvMd4heja-b5hV90WnmPgkNY/Users/"+user.uid);
                await us.on('value', (data) => { 
                    if(data.val()){
                        this.user = data.val();
                        console.log('user lga status', )
                        this.isLga = (this.user.email.search("@minq.com.au") > -1) ? true : false;
                        if(this.$route.name !== "Users" && this.$route.name !== "Programs"){
                            this.$router.push({name: "Classic"})
                        }
                    }else{
                        console.log('data is null')
                        this.$router.push({path: "/authentication/login"})
                    }
                },
                (error) => { console.log(error); this.$router.push({path: "/authentication/login"}) }
                )
                
            }else{
                console.log('no user data')
                // this.$router.push({path: "/authentication/login"})
            }
           
        },
        methods: {
            toTitleCase(str) {
                return str.replace(
                  /\w\S*/g,
                  function (txt) {
                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                  }
                );
              }
        },
       
        render: h => h(App)
    }).$mount('#app')
  });


